import React from 'react';
import { Grid, Table, Form, Button, Icon } from 'semantic-ui-react';
import { CircularProgressbar, buildStyles } from 'react-circular-progressbar';
import 'react-circular-progressbar/dist/styles.css';
import AddProductModal from '../components/AddProductModal.js';
import Truck from '../Images/lorryicon_small.png';
import PipesImage from '../Images/pipesImage.jpg';
import EasiBaseImage from '../Images/easibaseImage.jpg';
import SocketPipeImage from '../Images/socketPipesImage.jpg';
import LoadLorryImage from '../Images/loadLorry.jpg';
import "../custom.css";
import { Carousel } from 'react-carousel-minimal';

const data = [
    {
        image: PipesImage,
        caption: ""
    },
    {
        image: EasiBaseImage,
        caption: ""
    },
    {
        image: LoadLorryImage,
        caption: ""
    },
    {
        image: SocketPipeImage,
        caption: ""
    },
];

const captionStyle = {
    fontSize: '2em',
    fontWeight: 'bold',
}
const slideNumberStyle = {
    fontSize: '20px',
    fontWeight: 'bold',
}


export default class BuilderHome extends React.Component {

    state = {
        addProductModalOpen: false,
        NoProductsTitle: 'Add products to begin load building',
        HasProductsTitle: 'Add more products',
        TableProductHeader: 'Product',
        TableQtyHeader: 'Qty',
        LorryCapTitle: 'Lorry Capacity',
        Disclaimer: 'Load Builder is designed to maximise load sizes to ensure efficient utilisation of trucks. Please ensure truck is filled to maximum capacity where possible to avoid part load charges',
        FullLoadTitle: 'Full Loads'
    }

    CloseAddProductModal = () => {
        this.setState({ addProductModalOpen: false });
        this.props.ResetFilteredList();
    }

    UpdateFilteredList = (productGrpId, productCatId) => {
        this.props.UpdateFilteredList(productGrpId, productCatId);
    }

    UpdateFilteredProductGroupList = (productCatId) => {
        this.props.UpdateFilteredProductGroupList(productCatId);
    }

    AddProductToTable = (xrefId, qty) => {
        this.props.AddProductToTable(xrefId, qty);
    }

    handleQuantityChange(value, index) {

        const re = /^[0-9\b]+$/;
        if (re.test(value)) {
            this.props.UpdateQtyChange(value, index);

        }

    }

    handleRowRemove(index, xrefId) {

        const xrefIdInt = parseInt(xrefId);

        this.props.RemoveProductRow(index, xrefIdInt);

    }


    render() {

        if (this.state.addProductModalOpen) {
            return (<AddProductModal
                CloseAddProductModal={this.CloseAddProductModal}
                FilteredListOfProducts={this.props.FilteredListOfProducts}
                ListOfProductGroups={this.props.ListOfProductGroups}
                UpdateFilteredList={this.UpdateFilteredList}
                AddProductToTable={this.AddProductToTable}
                ListOfProductCategories={this.props.ListOfProductCategories}
                UpdateFilteredProductGroupList={this.UpdateFilteredProductGroupList}
            />);
        }



        return (<div>
            <br />

            <Grid columns={5}>
                <Grid.Row>
                    <Grid.Column width={9}>

                        {this.props.ListOfAddedProducts.length === 0 ?

                            <Button circular color='blue' onClick={() => this.setState({ addProductModalOpen: true })} >
                                <Icon color='white' name='truck' /> {this.state.NoProductsTitle}
                            </Button>
                            :
                            <Button circular color='blue' onClick={() => this.setState({ addProductModalOpen: true })} >
                                <Icon color='white' name='truck' /> {this.state.HasProductsTitle}
                            </Button>
                        }




                    </Grid.Column>

                    {this.props.ListOfAddedProducts.length === 0 ? null :

                        <><Grid.Column width={1}>
                        </Grid.Column>

                            <Grid.Column width={3}>
                                <h3>{this.state.LorryCapTitle}</h3>
                            </Grid.Column>

                            <Grid.Column width={2}>
                                <h3>{this.state.FullLoadTitle}</h3>
                            </Grid.Column>

                            <Grid.Column width={1}>
                            </Grid.Column></>

                    }




                </Grid.Row>

                <br />
                <br />

                {this.props.ListOfAddedProducts.length === 0 ?

                    <Grid.Row>

                        <Grid.Column width={1}>
                        </Grid.Column>

                        <Grid.Column width={14}>

                            <div style={{ textAlign: "center" }}>

                                <div style={{
                                    padding: "0 20px"
                                }}>
                                    <Carousel
                                        data={data}
                                        time={4000}
                                        width="850px"
                                        height="500px"
                                        captionStyle={captionStyle}
                                        radius="10px"
                                        slideNumber={true}
                                        slideNumberStyle={slideNumberStyle}
                                        captionPosition="bottom"
                                        automatic={true}
                                        dots={true}
                                        pauseIconColor="white"
                                        pauseIconSize="40px"
                                        slideBackgroundColor="darkgrey"
                                        slideImageFit="cover"
                                        thumbnails={true}
                                        thumbnailWidth="100px"
                                        style={{
                                            textAlign: "center",
                                            maxWidth: "950px",
                                            maxHeight: "600px",
                                            margin: "40px auto",
                                        }}
                                    />
                                </div>
                            </div>

                        </Grid.Column>

                        <Grid.Column width={1}>
                        </Grid.Column>

                    </Grid.Row>


                    :

                    <><Grid.Row>
                        <Grid.Column width={9}>
                            <Table celled>
                                <Table.Header>
                                    <Table.Row>
                                        <Table.HeaderCell width={11}>{this.state.TableProductHeader}</Table.HeaderCell>
                                        <Table.HeaderCell width={4}>{this.state.TableQtyHeader}</Table.HeaderCell>
                                        <Table.HeaderCell width={1}></Table.HeaderCell>
                                    </Table.Row>
                                </Table.Header>

                                <Table.Body>

                                    {this.props.ListOfAddedProducts.map((pro, i) => (
                                        <Table.Row key={i}>
                                            <Table.Cell>{pro.productName}</Table.Cell>
                                            <Table.Cell><Form.Group>
                                                <Form.Input transparent
                                                    placeholder='Qty'
                                                    type="number"
                                                    value={pro.quantity ? pro.quantity : 0}
                                                    onChange={e => this.handleQuantityChange(e.target.value, i)}
                                                    width={2} />
                                            </Form.Group></Table.Cell>
                                            <Table.Cell>
                                                <Form.Group>
                                                    <Form.Button
                                                        negative
                                                        size='mini'
                                                        icon='close'
                                                        onClick={e => this.handleRowRemove(i, pro.xrefId)}
                                                    ></Form.Button>
                                                </Form.Group>
                                            </Table.Cell>
                                        </Table.Row>
                                    ))}

                                </Table.Body>
                            </Table>
                        </Grid.Column>

                        <Grid.Column width={1}>
                        </Grid.Column>

                        <Grid.Column width={3}>
                            {this.props.PercentageFull < 80 ?
                                <div style={{ width: "70%" }}>
                                    <CircularProgressbar value={this.props.PercentageFull}
                                        text={`${this.props.PercentageFull}%`}
                                        styles={buildStyles({
                                            textColor: "red",
                                            pathColor: "red"
                                        })} />
                                </div>
                                :
                                <div style={{ width: "70%" }}>
                                    <CircularProgressbar value={this.props.PercentageFull}
                                        text={`${this.props.PercentageFull}%`}
                                        styles={buildStyles({
                                            textColor: "green",
                                            pathColor: "green"
                                        })} />
                                </div>}
                        </Grid.Column>

                        <Grid.Column width={1}>
                            <h3>{`${this.props.FullLoads} x `}</h3>
                        </Grid.Column>

                        <Grid.Column width={2}>
                            <img src={Truck} alt="truckImg" />
                        </Grid.Column>

                    </Grid.Row>

                        <Grid.Row>
                            <Grid.Column width={9}>
                                <h5>{this.state.Disclaimer}</h5>
                            </Grid.Column>
                        </Grid.Row></>
                }
            </Grid>
        </div>
        );

    }
}